import { RVFormItem, Tag } from "@regal-voice/ui";

import { TagSelectComponentProps, TagsSelect } from "./TagsSelect";

export interface TagsSelectOption {
    name?: string;
    label: React.ReactNode;
    value?: string | number | null;
    children?: Omit<TagsSelectOption, "children">[];
}

interface TagSelectFormItemProps extends TagSelectComponentProps {
    fieldName: string;
    label?: string;
    initialTags?: Array<TagsSelectOption>;
    addTagToEntityState?: (props: any) => void;
    isFullPageForm?: boolean;
}

export function tagOptions(tagsData?: Tag[]): TagsSelectOption[] {
    return tagsData?.map((tag: any) => {
        return {
            name: tag.name,
            label: tag.name,
            value: tag.id,
        };
    }) as TagsSelectOption[];
}

/**
 * Initial state of the tag select (when no action is performed in it) returns objects,
 * after updates it returns array of ids (value).
 */
export const parseFormTags = (tags: Array<any>): Array<string> => {
    return (tags || [])
        .map((tag) => {
            if (typeof tag === "string") {
                return tag;
            }

            const value = tag?.value;
            if (value === null || value === undefined) {
                return undefined;
            }

            return String(value);
        })
        .filter((value): value is string => typeof value === "string");
};

export function TagsSelectFormItem(props: TagSelectFormItemProps): JSX.Element {
    const { isFullPageForm, className, addTagToEntityState, initialTags, fieldName, label, onCreate, ...selectProps } =
        props;

    const createHandler = onCreate ?? addTagToEntityState;

    return (
        <RVFormItem
            key={`floating-${fieldName}`}
            className={className}
            name={fieldName}
            initialValue={initialTags}
            label={label ?? "Tags (Optional)"}
            isFullPageForm={isFullPageForm}
        >
            <TagsSelect hideEmptyDataMessage {...selectProps} onCreate={createHandler} />
        </RVFormItem>
    );
}
